<template>
    <div class="container-fluid">
        <div class="table-responsive">
            <table class="table table-bs is-bordered is-narrow is-hoverable">
                <thead>
                <tr>
                    <th scope="col">Bil</th>
                    <th scope="col">Jenis Wakaf</th>
                    <th scope="col">Daerah</th>
                    <th scope="col">Projek</th>
                    <th scope="col">Unit</th>
                    <th scope="col">Jumlah (RM)</th>
                    <th scope="col">Bagi Pihak</th>
                    <th scope="col">Nama Pemilik</th>
                    <th scope="col">Tambah/Batal</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in wakafData">
                    <td><span class="fs-6 align-middle">{{ index + 1 }}</span></td>
                    <td>
                        <select v-model="item.jenisWakaf" style="min-width: 110px;"
                                class="form-select"
                                required @change="wakafDaerah(parseInt(($event.target as HTMLInputElement).value), index)">
                            <option disabled selected value="0">Sila pilih</option>
                            <option v-for="type in data.wakaf_type" :value="type.id">{{ type.Nama }}</option>
                        </select>
                    </td>
                    <td>
                        <span v-if="item.jenisWakaf === 0" class="fs-6">Pilih jenis wakaf</span>
                        <span v-if="item.district_list.length === 0 && item.jenisWakaf !== 0" class="fs-6">Tidak berkenaan</span>
                        <select v-if="!item.isHiddenDistrict && item.jenisWakaf !== 0" v-model="item.daerahWakaf" style="min-width: 110px;"
                                :disabled="wakafData[index].isHiddenDistrict"
                                class="form-select" required @change="daerahProjek(parseInt(($event.target as HTMLInputElement).value), item, index)">
                            <option disabled selected value="0">Pilih Daerah</option>
                            <option v-for="daerah in wakafData[index].district_list" :value="daerah.KodDaerah">
                                {{ daerah.daerah }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="item.jenisWakaf === 0 && item.daerahWakaf === 0" class="fs-6">Pilih jenis wakaf</span>
                        <span v-else-if="item.jenisWakaf === 2 && item.daerahWakaf === 0" class="fs-6">Pilih daerah dahulu</span>
                        <span v-else-if="item.jenisWakaf !== 2 && item.daerahWakaf === 0" class="fs-6">Tidak berkenaan</span>
                        <span v-else-if="item.jenisWakaf !== 2 && item.daerahWakaf !== 0" class="fs-6">Tidak berkenaan</span>
                        <select v-if="item.jenisWakaf === 2 && item.daerahWakaf !== 0" v-model="item.projekWakaf"
                                style="min-width: 110px;"
                                :disabled="wakafData[index].isHiddenProject" class="form-select" required>
                            <option value="0" selected disabled>Pilih projek</option>
                            <option v-for="project in wakafData[index].project_list" :value="project.kod">
                                {{ project.nama }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <div style="width: 156px !important;">
                            <button class="btn btn-info" type="button"
                                    @click="increment(false, item)"
                            ><font-awesome-icon :icon="faMinus" />
                            </button>
                            <input v-model="item.unit" style="width: 64px" autocomplete="off" class="form-control d-inline text-center" max="200000000"
                                   min="1"
                                   placeholder="Unit" required
                                   type="number" @input="typeValueUpdate(($event.target as HTMLInputElement).value, item, index)"/>
                            <button class="btn btn-info"
                                    type="button"
                                    @click="increment(true, item)"><font-awesome-icon :icon="faPlus" />
                            </button>
                        </div>
                    </td>
                    <td>
                        <span class="fs-5">{{ sumFormat(item.jumlah) }}</span>
                    </td>
                    <td>
                        <select v-model="item.jenisPemilik" style="min-width: 110px;" class="form-select"
                                required
                                @change="setWakafOwnName($event, item)">
                            <option disabled selected value="">Sila pilih</option>
                            <option v-for="jp in jenisPemilik" :value="jp">{{ jp }}</option>
                        </select>
                    </td>
                    <td><input v-if="item.jenisPemilik !== 'Sendiri'" v-model="item.namaPemilik" style="min-width: 110px;"
                               class="form-control" placeholder="Nama pemilik" required
                               type="text"
                               @input="updateParentName(($event.target as HTMLInputElement).value, item, index)"/>
                        <span v-if="item.jenisPemilik === 'Sendiri'" class="fs-6 name">{{ item.namaPemilik }}</span>
                    </td>
                    <td>
                        <div class="btn-group" role="group">
                            <button v-if="index !== 9" class="btn btn-primary" style="margin-right:10px;" type="button"
                                    @click="addRow()"><font-awesome-icon :icon="faPlus" /></button>
                            <button v-if="index !== 0" class="btn btn-danger is-focused wakaf-del" type="button"
                                    @click="removeRow(index)"><font-awesome-icon :icon="faTrash" /></button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script lang="ts" setup>
import {onMounted, ref} from "vue";
import Swal from "sweetalert2"
import {sumFormat} from "../../utils/utils";
import type {FormGeneral} from "../interface/FormGeneral";
import { faPlus, faMinus, faTrash, faPaperPlane} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faPlus, faMinus, faTrash, faPaperPlane);

const data = defineProps<{
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    nama_pewakaf: string,
    userdata?: [IuserData],
    w_id?: number,
    d_id?: number,
    p_id?: number,
}>();
const emitToExternal = defineEmits<{
    (e: "calulateSum", sum: number): void,
    (e: "updateName", name: String, ownerType: String): void,
}>()
const wakafData = ref<FormGeneral[]>([]);

interface IuserData {
    ID: number,
    JenisWakaf: number,
    KodDaerah: number,
    Projek: number,
    Unit: number,
    jumlah: number,
    JenisPemilikan: string,
    NamaPemilik: string,
    Amaun: number,
    NoResitt: number,
    WakafResitID: number
}


defineExpose({
    wakafData
})
const jenisPemilik = ref<string[]>(["Sendiri", "Mewakili Orang", "Mewakili Orang Meninggal"])
const wakafDaerah = (jenisWakaf: number, index: number, repeat?: number): void => {
    if (typeof repeat === "undefined") {
        wakafData.value[index].projekWakaf = 0;
        wakafData.value[index].daerahWakaf = 0;
    }
    wakafData.value[index].isHiddenDistrict = true;
    wakafData.value[index].district_list = [];
    switch (jenisWakaf){
        case 1: // Tabung wakaf tunai
            wakafData.value[index].projekWakaf = 26;
            wakafData.value[index].district_list = data.wakaf_district;
            wakafData.value[index].isHiddenDistrict = false;
            break;
        case 2: // Tabung wakaf projek
            let districtProjek: { KodDaerah: number, daerah: string }[] = getDaerahProjectIncluded();
            if (districtProjek.length > 0){
                wakafData.value[index].district_list = districtProjek;
                wakafData.value[index].isHiddenDistrict = false;
            }
            break;
        case 3: // Tabung wakaf masjid
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 3;
            break;
        case 4: // Tabung wakaf pendidikan
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 5;
            break;
        case 5: // Wakaf tunai
            wakafData.value[index].daerahWakaf = 99;
            wakafData.value[index].projekWakaf = 58;
            break;
    }
}

const getDaerahProjectIncluded = () : { KodDaerah: number, daerah: string }[] =>{
    let filteredDistricts: { KodDaerah: number, daerah: string }[] = [];
    const uniqueDistrictIDs = new Set();
    for (let p = 0; p < data.wakaf_project.length; p++){
        if(![3,5,26].includes(data.wakaf_project[p].kod) && data.wakaf_project[p].WakafJenisID ===2){
            uniqueDistrictIDs.add(data.wakaf_project[p].DaerahID);
        }
    }
    for (let q = 0; q < data.wakaf_district.length; q++){
        if(uniqueDistrictIDs.has(data.wakaf_district[q].KodDaerah)){
            filteredDistricts.push({
                KodDaerah : data.wakaf_district[q].KodDaerah,
                daerah : data.wakaf_district[q].daerah
            });
        }
    }
    return filteredDistricts;
}

const daerahProjek = (daerah: number, item: FormGeneral, index: number, repeat?: number): void => {
    if (typeof repeat === "undefined") {
        wakafData.value[index].projekWakaf = 0;
    }
    if (wakafData.value[index].jenisWakaf === 1){
        wakafData.value[index].projekWakaf = 26;
    }
    wakafData.value[index].project_list = [];
    wakafData.value[index].formError.daerahWakaf.valid = true;
    wakafData.value[index].formError.daerahWakaf.message = "";
    let filteredProjects: { kod: number, nama: string }[] = getProjectFiltered(item.jenisWakaf, daerah);
    if(filteredProjects.length > 0){
        wakafData.value[index].isHiddenProject = false;
        wakafData.value[index].project_list = filteredProjects;
    }
}
const getProjectFiltered = (jenisWakaf: number, daerah: number) : { kod: number, nama: string }[] =>{
    let filteredProjects: { kod: number, nama: string }[] = [];
    data.wakaf_project.forEach(function (item) {
        if (item["WakafJenisID"] === jenisWakaf && item["DaerahID"] === daerah) {
            filteredProjects.push({
                kod : item["kod"],
                nama : item["nama"]
            });
        }
    });
    return filteredProjects;
}
const increment = (isIncrease: Boolean, item: FormGeneral): void => {
    if (isIncrease && item.unit <= 200000000) {
        item.unit++;
    } else if (!isIncrease && item.unit > 1) {
        item.unit--;
    }
    item.jumlah = item.unit * 5;
    calulcateAllSum();
};

const typeValueUpdate = (typedValue: string, item: FormGeneral, index: number): void => {
    if (typedValue.match(/[^a-zA-Z0-9 ]/) || parseInt(typedValue) < 1 || parseInt(typedValue) >= 200000000) {
        wakafData.value[index].unit = 1;
    }
    if (isNaN(parseInt(typedValue))) {
        wakafData.value[index].unit = 1;
    }
    item.jumlah = item.unit * 5;
    calulcateAllSum();
}

const setWakafOwnName = (event: Event, item: FormGeneral): void => {
    const target = event.target as HTMLSelectElement;
    if (target.value === "Sendiri") {
        item.namaPemilik = data.nama_pewakaf;
        wakafData.value.forEach(function (itemm, indexx) {
            if (wakafData.value[indexx].jenisPemilik === "Sendiri") {
                wakafData.value[indexx].namaPemilik = data.nama_pewakaf
            }
        })
    } else {
        item.namaPemilik = ""
    }
}

const updateParentName = (name: string, item: FormGeneral, index: number): void => {
    if (item.jenisPemilik === "Sendiri") {
        wakafData.value.forEach(function (itemm, indexx) {
            if (wakafData.value[indexx].jenisPemilik === "Sendiri") {
                wakafData.value[indexx].namaPemilik = name
            }
        })
    }
    emitToExternal("updateName", wakafData.value[index].namaPemilik, wakafData.value[index].jenisPemilik);
}

const calulcateAllSum = (): void => {
    let sum: number = 0;
    wakafData.value.forEach(function (itemm) {
        sum += itemm.jumlah;
    })
    emitToExternal("calulateSum", sum);
}
const addRow = (): void => {
    if (wakafData.value.length < 10) {
        pushRow();
    } else if (wakafData.value.length >= 10) {
        Swal.fire({
            position: "center",
            icon: "info",
            title: "Hanya 10 transaksi dibenarkan bagi setiap pewakaf",
            timerProgressBar: true,
            timer: 1000
        })
    }
}

const pushRow = (): void => {
    wakafData.value.push({
        jenisWakaf: 0,
        daerahWakaf: 0,
        projekWakaf: 0,
        unit: 1,
        jumlah: 5,
        jenisPemilik: "",
        namaPemilik: "",
        district_list: [],
        project_list: [],
        isHiddenDistrict: true,
        isHiddenProject: true, // not in use
        isUpdate: false, // not in use
        editModalIndex: 0, // not in use
        formError:{
            jenisWakaf:{
                valid: true,
                message: "",
            },
            daerahWakaf:{
                valid: true,
                message: "",
            },
            projekWakaf:{
                valid: true,
                message: "",
            },
            unitWakaf:{
                valid: true,
                message: "",
            },
            pihakWakaf:{
                valid: true,
                message: "",
            },
            namaPemilikWakaf:{
                valid: true,
                message: "",
            },
        },
    });
    calulcateAllSum();
}
const removeRow = (index: number): void => {
    wakafData.value.splice(index, 1);
    calulcateAllSum();
}

onMounted(() => {
    if (data.userdata === undefined) {
        pushRow();
    } else {
        wakafData.value = [];
        for (let i = 0; i < data.userdata.length; i++) {
            let unitt: number;
            let jumlahh: number;
            let projectCheck :{
                jenis: number,
                daerah: number,
                projek: number,
                isDisabledProject: boolean,
            } = {
                jenis: data.userdata[i].JenisWakaf,
                daerah: data.userdata[i].KodDaerah,
                projek: data.userdata[i].Projek,
                isDisabledProject: true,
            };
            if (data.userdata[i].Amaun < 5) {
                unitt = 1;
                jumlahh = 5;
            } else {
                unitt = Math.ceil(data.userdata[i].Amaun / 5);
                jumlahh = Math.ceil(data.userdata[i].Amaun / 5) * 5;
            }

            let noMatchedProjectFlag: boolean = false;
            for(let j: number = 0; j < data.wakaf_project.length; j++){
                if (data.wakaf_project[j].kod === data.userdata[i].Projek){
                    noMatchedProjectFlag = true;
                    break;
                }
            }

            if(!noMatchedProjectFlag){
                projectCheck.jenis = 1;
                projectCheck.daerah = 1;
                projectCheck.projek = 26;
                projectCheck.isDisabledProject = true;
            }

            const wd: FormGeneral = {
                jenisWakaf: projectCheck.jenis,
                daerahWakaf: projectCheck.daerah,
                projekWakaf: projectCheck.projek,
                unit: unitt,
                jumlah: jumlahh,
                jenisPemilik: data.userdata[i].JenisPemilikan,
                namaPemilik: data.userdata[i].NamaPemilik,
                district_list: [],
                project_list: [],
                isHiddenDistrict: projectCheck.isDisabledProject,
                isHiddenProject: false, // not in use
                isUpdate: false, // not in use
                editModalIndex: 0, // not in use
                formError:{
                    jenisWakaf:{
                        valid: true,
                        message: "",
                    },
                    daerahWakaf:{
                        valid: true,
                        message: "",
                    },
                    projekWakaf:{
                        valid: true,
                        message: "",
                    },
                    unitWakaf:{
                        valid: true,
                        message: "",
                    },
                    pihakWakaf:{
                        valid: true,
                        message: "",
                    },
                    namaPemilikWakaf:{
                        valid: true,
                        message: "",
                    },
                },
            };
            wakafData.value.push(wd);
            wakafDaerah(projectCheck.jenis, i, 1);
            daerahProjek(projectCheck.daerah, wd, i ,1)
        }
    }
    calulcateAllSum();
})
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.name {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}
</style>
